import { useQuery } from '@tanstack/vue-query'
import { computed, toValue } from 'vue'

import type { UseEntityQueryOptions } from '@/support/query/UseEntityQueryOptions.types'

import { callMeasurementUnits } from '@/domains/measurement-units/services'
import { STALE_TIMES } from '@/support/query/constants'

export const MEASUREMENT_UNITS_QUERY_KEY = ['measurementUnits'] as const

/** The catalogue's query, shared so code outside a component can read the same cache entry. */
export const measurementUnitsQueryOptions = {
  queryKey: [...MEASUREMENT_UNITS_QUERY_KEY, 'all'],
  queryFn: async () => {
    const response = await callMeasurementUnits().index()
    return response.data.value ?? []
  },
  staleTime: STALE_TIMES.LOW_CHURN
}

/**
 * TanStack Query composable for fetching all measurement units.
 *
 * Measurement units are a bounded, low-churn dataset — fetched once and cached.
 * Consumers filter and look up locally rather than via API search.
 */
export const useMeasurementUnitsQuery = (options: UseEntityQueryOptions = {}) => {
  return useQuery({
    ...measurementUnitsQueryOptions,
    enabled: computed(() => toValue(options.enabled) ?? true)
  })
}
